"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Container = exports.StyledIcon = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _rebass = require("rebass");

var _Icon = _interopRequireDefault(require("../Icon"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var Arrow = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var _style;

  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      carousel = _ref$theme.carousel,
      space = _ref$theme.space;
  var style = (_style = {
    position: 'absolute',
    zIndex: 1,
    top: "-".concat(space.xlarge),
    transform: 'translate(0, -75%)',
    display: 'none',
    padding: space.xsmall,
    cursor: 'pointer',
    lineHeight: 0,
    border: 'none',
    borderRadius: carousel.arrowBorderRadius,
    outline: 'none',
    opacity: carousel.arrowOpacity,
    background: colors[carousel.arrowBg],
    transition: 'all .3s ease-in-out',
    '&:hover': {
      opacity: '1'
    }
  }, _defineProperty(_style, _mediaQueries.default.small, {
    display: 'block'
  }), _defineProperty(_style, _mediaQueries.default.medium, {
    padding: space[carousel.arrowPadding]
  }), _style);
  return (0, _styledSystem.variant)({
    variants: {
      left: _objectSpread(_objectSpread({}, style), {}, {
        right: space.xxlarge,
        transform: 'translate(0, -75%) rotate(180deg)',
        transformOrigin: 'center'
      }),
      right: _objectSpread(_objectSpread({}, style), {}, {
        right: 0
      })
    }
  });
});
var StyledIcon = (0, _styled.default)(_Icon.default)(function (_ref2) {
  var carousel = _ref2.theme.carousel;
  return {
    transform: carousel.iconTransform
  };
});
exports.StyledIcon = StyledIcon;
var Container = (0, _styled.default)(_rebass.Box)(function (_ref3) {
  var _ref4;

  var _ref3$theme = _ref3.theme,
      carousel = _ref3$theme.carousel,
      space = _ref3$theme.space,
      variant = _ref3.variant;
  return _ref4 = {
    margin: "0 -".concat(space.xsmall)
  }, _defineProperty(_ref4, _mediaQueries.default.small, {
    margin: "0 -".concat(space.medium)
  }), _defineProperty(_ref4, '.slick-slider .slick-list', {
    display: variant === 'profile' ? 'flex' : 'block'
  }), _defineProperty(_ref4, '.slick-slider::after', {
    background: "linear-gradient(to left, rgba(".concat(carousel.shadowBackgroundRGB, ",1) 0%,rgba(").concat(carousel.shadowBackgroundRGB, ",0) 100%)")
  }), _ref4;
});
exports.Container = Container;
var _default = Arrow;
exports.default = _default;